var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJoin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9209 11.62C21.8733 11.4972 21.8019 11.3851 21.7109 11.29L17.7109 7.28996C17.3188 6.89784 16.683 6.89784 16.2909 7.28996C15.8988 7.68209 15.8988 8.31784 16.2909 8.70996L18.5909 11H5.41087L7.71087 8.70996C7.96453 8.45631 8.0636 8.08659 7.97075 7.74009C7.87791 7.39358 7.60725 7.12293 7.26075 7.03009C6.91425 6.93724 6.54453 7.03631 6.29087 7.28996L2.29087 11.29C2.19983 11.3851 2.12847 11.4972 2.08087 11.62C1.98085 11.8634 1.98085 12.1365 2.08087 12.38C2.12847 12.5027 2.19983 12.6149 2.29087 12.71L6.29087 16.71C6.47864 16.8993 6.73424 17.0058 7.00087 17.0058C7.26751 17.0058 7.52311 16.8993 7.71087 16.71C7.90019 16.5222 8.00667 16.2666 8.00667 16C8.00667 15.7333 7.90019 15.4777 7.71087 15.29L5.41087 13H18.5909L16.2909 15.29C16.1016 15.4777 15.9951 15.7333 15.9951 16C15.9951 16.2666 16.1016 16.5222 16.2909 16.71C16.4786 16.8993 16.7342 17.0058 17.0009 17.0058C17.2675 17.0058 17.5231 16.8993 17.7109 16.71L21.7109 12.71C21.8019 12.6149 21.8733 12.5027 21.9209 12.38C22.0209 12.1365 22.0209 11.8634 21.9209 11.62Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoin);
export default ForwardRef;